import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

import { BackendStatusService } from '../../services/backend-status/backend-status.service';

@Component({
  selector: 'app-under-construction',
  imports: [ButtonModule, TranslateModule],
  templateUrl: './under-construction.component.html',
  styleUrl: './under-construction.component.scss'
})
export class UnderConstructionComponent {
  constructor(private readonly backendStatusService: BackendStatusService) {}

  protected checkBackendAgain(): void {
    this.backendStatusService.checkBackendReachability();
  }
}
